import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // For now, just use a simple password check
    // In production, this should validate against the backend
    if (password === 'admin123') {
      login('dummy-token');
      navigate('/tours');
    } else {
      setError('Invalid password');
    }
  };

  // For development, auto-login
  React.useEffect(() => {
    login('dummy-token');
    navigate('/tours');
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #F5E6D3 0%, #EDE4D6 50%, #E8DCC8 100%)',
      }}
    >
      <Container component="main" maxWidth="xs">
        <Paper
          elevation={6}
          sx={{
            padding: 4,
            width: '100%',
            borderRadius: 3,
            border: '2px solid rgba(212, 175, 55, 0.4)',
            background: 'linear-gradient(180deg, #FFFDF8 0%, #FAF8F3 100%)',
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <Box
              component="img"
              src="/logoHistoria.png"
              alt="Historia"
              sx={{
                maxWidth: '200px',
                height: 'auto',
                filter: 'drop-shadow(0 2px 4px rgba(139, 69, 19, 0.3))',
              }}
            />
          </Box>
          <Typography
            component="h1"
            variant="h5"
            align="center"
            sx={{
              color: '#5C4033',
              fontWeight: 600,
              mb: 2,
            }}
          >
            Manager
          </Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Accedi
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default Login;